import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import NewContentItem from './NewContentItem';

//import PerfectScrollbar from 'react-perfect-scrollbar';

class NewContentList extends Component {
  state = {};
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getContent();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getContent = async (api) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(api);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          contentList,
        });
      }
    }
  };
  _getContentApi = (api) => {
    const { apiUrl, loginId } = this.props;
    //const sameCode = 202010;
    const { sameCode } = this.props.childProps;

    return axios
      .post(apiUrl + '/eventContent', {
        params: {
          loginId: loginId,
          sameCode: sameCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <NewContentItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          genre={item.genre}
          img={item.img}
          weekNo={item.weekNo}
          weekTime={item.weekTime}
          comment={item.comment}
          comment1={item.comment1}
          comment2={item.comment2}
        />
        /*
                <div className="div_li" style={{width: 240}} key={index}>
                    <div className="list_img_bg" style={{ cursor: 'pointer'}} onClick={()=>this._onItem(item.contentSerial)}><img src={item.img}/></div>
                    <p style={{ cursor: 'pointer'}} onClick={()=>this._onItem(item.contentSerial)}>{item.title}<span>{item.genre}</span></p>
                </div>
                */
      );
    });

    return list;
  };
  render() {
    const { contentList } = this.state;
    return (
      <Fragment>
        <ul>
          {contentList ? this._renderItem() : null}
          {/*
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list01.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list02.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list03.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    <li>
                        <div className="thumb"><img src="/img/event/20201218/list04.png"/></div>
                        <p className="subject">카구야 님은 고백받고 싶어 ~ The Final Season...</p>
                        <button type="button"><span>신작 공유하기</span></button>
                    </li>
                    */}
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(NewContentList));
